import axios from 'axios';

/*
* Member History Actions
*/

export const FETCH_MEMBER_HISTORY_REQUEST = 'FETCH_MEMBER_HISTORY_REQUEST';
export const FETCH_MEMBER_HISTORY_SUCCESS = 'FETCH_MEMBER_HISTORY_SUCCESS';
export const FETCH_MEMBER_HISTORY_FAIL = 'FETCH_MEMBER_HISTORY_FAIL';
export const REVERT_MEMBER_REQUEST = 'REVERT_MEMBER_REQUEST';
export const REVERT_MEMBER_SUCCESS = 'REVERT_MEMBER_SUCCESS';
export const REVERT_MEMBER_FAIL = 'REVERT_MEMBER_FAIL';
export const CLEAR_MEMBER_HISTORY = 'CLEAR_MEMBER_HISTORY';


/* Fetch Member History */
export function fetchMemberHistory(memberId) {
    return function (dispatch) {
        dispatch(fetchMemberHistoryRequest(memberId));
        
        const request = axios.get(
            `${process.env.REACT_APP_ENDPOINT_URL}/v1/member-history/${memberId}`
        );
          
        return request.then(
            response => dispatch(fetchMemberHistorySuccess(memberId, response.data.history)),
            err => dispatch(fetchMemberHistoryFail(memberId, err))
        );
    };
}

function fetchMemberHistoryRequest(memberId) {
    return { 
        type: FETCH_MEMBER_HISTORY_REQUEST,
        memberId
    };
}

function fetchMemberHistorySuccess(memberId, history) {
    return { 
        type: FETCH_MEMBER_HISTORY_SUCCESS, 
        memberId,
        history,
        receivedAt: Date.now()
    };
}

function fetchMemberHistoryFail(memberId, error) {
    return { 
        type: FETCH_MEMBER_HISTORY_FAIL, 
        memberId,
        error
    };
}


/* Revert Member to specific history entry */
export function revertMember(historyId, memberId) {
    return function (dispatch) {
        dispatch(revertMemberRequest(historyId));
        
        const request = axios.post(
            `${process.env.REACT_APP_ENDPOINT_URL}/v1/member-history/revert/${historyId}`
        );
          
        return request.then(
            response => {
                dispatch(revertMemberSuccess(response.data.member));
                // Refresh history after revert
                dispatch(fetchMemberHistory(memberId));
                return response.data;
            },
            err => {
                dispatch(revertMemberFail(err));
                throw err;
            }
        );
    };
}

function revertMemberRequest(historyId) {
    return { 
        type: REVERT_MEMBER_REQUEST,
        historyId
    };
}

function revertMemberSuccess(member) {
    return { 
        type: REVERT_MEMBER_SUCCESS, 
        member,
        receivedAt: Date.now()
    };
}

function revertMemberFail(error) {
    return { 
        type: REVERT_MEMBER_FAIL, 
        error
    };
}


/* Clear member history from state */
export function clearMemberHistory() {
    return { 
        type: CLEAR_MEMBER_HISTORY
    };
}
